var path = '/templates/projects/views/maintenance.html';
var html = "<div id=wrapper><div class=content><div class=\"container text-center\"><br><br><i class=\"fa fa-wrench\" style=\"font-size:180px;color:rgb(228, 228, 228)\"></i><br><br><br><br><h2>{{ 'projects.views.maintenance.shisutemumentenansu_uchi_de' | translate }}</h2><p>{{ 'projects.views.maintenance.go_riyou_no' | translate }}<br>{{ 'projects.views.maintenance.mentenansu_shuuryou_made' | translate }}</p><p>{{ 'projects.views.maintenance.o_isogi_no' | translate }}</p></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects/views/maintenance.html
// module id = 1615
// module chunks = 0